<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <div class="form-row">
    <label class="col-sm-4 col-form-label"
           for="geburtsdatum{{index}}">
      {{ 'COMMON_UI.PERSON.GEBURTSDATUM' | translate }}
    </label>
    <div class="col-sm-8">
      <date-picker
              id="geburtsdatum{{index}}"
              messagePath="geburtsdatum{{objectId}}"
              formControlName="geburtsdatum"
              [isRequired]=true>
      </date-picker>
    </div>
  </div>

  <div class="form-row">
    <label class="col-sm-4 col-form-label"
           for="identifikationsnummer{{index}}">
      {{ 'COMMON_UI.PERSON.IDENTIFIKATIONSNUMMER' | translate }}
    </label>
    <div class="col-sm-8">
      <input class="form-control" datevMessagePath="identifikationsnummer{{objectId}}" formControlName="identifikationsnummer"
             id="identifikationsnummer{{index}}"
             type="text" utilsCheckValidity
             utilsControlState utilsValidationMessage/>
    </div>
  </div>
</form>
